module.exports = __webpack_public_path__ + "assets/img/meeting-icon.jpg";